module.exports = __webpack_public_path__ + "static/devonJump.8db71151.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/devonJump.png
// module id = 394
// module chunks = 35783957827783 195814232070997